import Nullstack from 'nullstack';
export default function IconMotorbike({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-motorbike",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "16",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "16",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M13 6h2l1.5 3l2 4"
  }), " ");
}